import { RefDataState } from "app/pages/DiscountEditor/modules/RefData/state";

function getRoot(state: any) : RefDataState {
    return state.refData;
}

export function getAllBookingSystems(state: any) {
    return getRoot(state).allBookingSystems; 
}

export function getAllCurrencies(state: any) {
    return getRoot(state).allCurrencies; 
}